import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  wrapperUpdateUserUI
} from '../javascript.js';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  lastKnownSubscriptionInfo = {};
  lastKnownUserIdOnClient = null;

  constructor(private http: HttpClient, private logger: LoggerService) {
    this.getUserIdFromServer();
  }

  getUserId() {
    //return window.sessionStorage['userid'];
    return window.sessionStorage.getItem('userid');
  }

  logout() {
    this.saveUserId(null);
    var promise = new Promise((resolve, reject) => {
      this.http.delete("api/authstring").subscribe({
        next: (data: any) => {
          this.saveUserId(null);
          resolve(data)
        },
        error: (err: Error) => reject(this.logger.logApiError(err, "logout"))
      });
    });
    return promise;
  }

   getLogoUrl() {
     var promise = new Promise((resolve, reject) => {
       this.http.get("api/logourl").subscribe({
         next: (data: any) => resolve(data),
         error: (err: Error) => reject(this.logger.logApiError(err, "getLogoUrl"))
       });
     });
     return promise;
  }

  saveUserId(userId) {
    if (userId) {
      if (this.lastKnownUserIdOnClient != userId) {
        this.lastKnownUserIdOnClient = userId;
        window.sessionStorage.setItem('UserId', userId);
        this.getSubscriptionInfo(null, null);
      }
    } else {
      window.sessionStorage.removeItem('UserId');
      this.updateSubscriptionInfoCSS(false);
    }
    wrapperUpdateUserUI();
  }

  getUserIdFromServer() {
    var promise = new Promise((resolve, reject) => {
      this.http.get("api/userid").subscribe({
        next: (data: any) => {
          try {
            if (data && data.status === 0 && data.userId) {
              this.saveUserId(data.userId);
            } else {
              this.saveUserId(null);
            }
          }
          catch (e) {
            this.logger.logInternalError("USER SERVICE: getUserIdFromServer", e.message);
          }
        },
        error: (err: Error) => reject(this.logger.logApiError(err, "getLogoUrl"))
      });
    });
    return promise;    
  }

  logApiError(response, method) {
  return this.logger.logApiError(response, method);
  }

  getCurrentPath(state) {
    var path = window.localStorage['currentPath'];
    if (path === null || path === undefined)
      path = sessionStorage.getItem('currentPath-local');

    if (path) {
      var pathInfo = atob(path);
      return JSON.parse(pathInfo);
    } else {
      return { path: "/", search: "", state: "" };
    }
  }

  setOpenPopupAfterLogin(open) {
    window.localStorage['popup'] = open;

    // FireFox has a bug where localStorage gets erased if domain changes during workflow (e.g. OAuth sign in) in private window.
    // As a fall-back we store data to localStorage, too:
    sessionStorage.setItem('popup-local', open);
  }

  getOpenPopupAfterLogin(openWhat) {
    var popup = window.localStorage['popup'];
    if (popup === null || popup === undefined)
      popup = sessionStorage.getItem('popup-local');

    if (popup === null || popup === undefined) return false;
    return popup === openWhat;
  }

  getDownloadPDFWithOCR() {
    var ocr = window.localStorage['downloadPDFWithOCR'];
    if (ocr === null || ocr === undefined)
      ocr = sessionStorage.getItem('downloadPDFWithOCR-local');

    if (ocr === null || ocr === undefined) return false;
    return ocr === 'yes';
  }

  setPreviewPDFOnly(previewPDFOnly) {
    window.localStorage['previewPDFOnly'] = (previewPDFOnly ? 'yes' : 'no');

    // FireFox has a bug where localStorage gets erased if domain changes during workflow (e.g. OAuth sign in) in private window.
    // As a fall-back we store data to localStorage, too:
    sessionStorage.setItem('previewPDFOnly-local', (previewPDFOnly ? 'yes' : 'no'));
  }

  getPreviewPDFOnly() {
    var val = window.localStorage['previewPDFOnly'];
    if (val === null || val === undefined)
      val = sessionStorage.getItem('previewPDFOnly-local');

    if (val === null || val === undefined) return false;
    return val === 'yes';
  }

  setDownloadFileType(fileType) {
    window.localStorage['downloadFileType'] = fileType;

    // FireFox has a bug where localStorage gets erased if domain changes during workflow (e.g. OAuth sign in) in private window.
    // As a fall-back we store data to localStorage, too:
    sessionStorage.setItem('downloadFileType-local', fileType);
  }

  getDownloadFileType() {
    var val = window.localStorage['downloadFileType'];
    if (val === null || val === undefined)
      val = sessionStorage.getItem('downloadFileType-local');

    if (val === null || val === undefined) return 'pdf';
    return val;
  }

  setDownloadPNGPage(pageNumber) {
    window.localStorage['downloadPNGPage'] = pageNumber;

    // FireFox has a bug where localStorage gets erased if domain changes during workflow (e.g. OAuth sign in) in private window.
    // As a fall-back we store data to localStorage, too:
    sessionStorage.setItem('downloadPNGPage-local', pageNumber);
  }

  getDownloadPNGPage() {
    var val = window.localStorage['downloadPNGPage'];
    if (val === null || val === undefined)
      val = sessionStorage.getItem('downloadPNGPage-local');

    if (val === null || val === undefined) return 1;
    return val;
  }

  setDownloadPDFWithOCR(downloadPDFWithOCR) {
    window.localStorage['downloadPDFWithOCR'] = (downloadPDFWithOCR ? 'yes' : 'no');

    // FireFox has a bug where localStorage gets erased if domain changes during workflow (e.g. OAuth sign in) in private window.
    // As a fall-back we store data to localStorage, too:
    sessionStorage.setItem('downloadPDFWithOCR-local', (downloadPDFWithOCR ? 'yes' : 'no'));
  }

  setSelectedOCRLanguages(langs) {
    window.localStorage['selectedOCRLanguages'] = langs;

    // FireFox has a bug where localStorage gets erased if domain changes during workflow (e.g. OAuth sign in) in private window.
    // As a fall-back we store data to localStorage, too:
    sessionStorage.setItem('selectedOCRLanguages-local', langs);
  }

  hasSubscriptionForSku(sku) {
  if (sku == null || sku == undefined)
    sku = "scanwritr-online-subscription-12m";

    var promise = new Promise((resolve, reject) => {
      this.http.get("api/app/hassubscription/?sku=" + sku).subscribe({
        next: (data: any) => {
          if (sku == 'scanwritr-online-subscription-12m' && data && data.status == 1) {
            this.updateSubscriptionInfoCSS(false);
          }
          resolve(data)
        },
        error: (err: Error) => reject(this.logger.logApiError(err, "hasSubscriptionForSku"))
      });
    });
    return promise;  
  }

  hasSubscription(checkForAnyExportSubscription, checkForFullSubscription) {
    //return http.get("api/app/hassubscription").then(
    //  response => { return response.data; },
    //  response => { return logApiError(response, 'hasSubscription'); });
    var sku = '';
    if (checkForAnyExportSubscription)
      sku = "scanwritr-online-subscription-export-also";
    else if (checkForFullSubscription)
      sku = "scanwritr-online-subscription";

     var promise = new Promise((resolve, reject) => {
       this.http.get("api/app/hassubscription/?sku=" + sku).subscribe({
         next: (data: any) => resolve(data),
         error: (err: Error) => reject(this.logger.logApiError(err, "hasSubscription"))
       });
      });
    return promise;    
  }

  getSubscriptionInfo(defaultCountry, defaultCurrency) {
    if (defaultCountry === null || defaultCountry === undefined)
      defaultCountry = "";
    if (defaultCurrency === null || defaultCurrency === undefined)
      defaultCurrency = "";

    var promise = new Promise((resolve, reject) => {
      this.http.get("api/app/subscriptioninfo?DefaultCountry=" + encodeURIComponent(defaultCountry) + "&DefaultCurrency=" + encodeURIComponent(defaultCurrency)).subscribe({
        next: (data: any) => {
          this.lastKnownSubscriptionInfo = data;
          if (data && data.sku == 'scanwritr-online-subscription-12m') {
            this.updateSubscriptionInfoCSS(false);
          } else {
            this.updateSubscriptionInfoCSS(true);
          }
          resolve(data)
        },
        error: (err: Error) => reject(this.logger.logApiError(err, "getSubscriptionInfo"))
      });
    });
    return promise; 
    //return http.get("api/app/subscriptioninfo?DefaultCountry=" + encodeURIComponent(defaultCountry) + "&DefaultCurrency=" + encodeURIComponent(defaultCurrency)).then(
    //  response => { return response.data; },
    //  response => { return logApiError(response, 'getSubscriptionInfo'); }
    //);
  }

  updateSubscriptionInfoCSS(userCanUpgrade) {
    try {
      if (userCanUpgrade == true && document.body.classList.contains('user-can-upgrade') == false) {
        document.body.classList.add('user-can-upgrade');
      }
      if (userCanUpgrade == false && document.body.classList.contains('user-can-upgrade') == true) {
        document.body.classList.remove('user-can-upgrade');
      }
    } catch (ex) {
      console.log(ex);
    }
  }

  getLastKnownSubscriptionInfo() {
    return this.lastKnownSubscriptionInfo;
  }

  getSelectedOCRLanguages() {
    var langs = window.localStorage['selectedOCRLanguages'];
    if (langs === null || langs === undefined)
      langs = sessionStorage.getItem('selectedOCRLanguages-local');

    if (langs === null || langs === undefined) return null;
    return langs;
  }

  saveCurrentPath(path, search, state) {
    var pathInfo = { path: path, search: search, state: state };
    window.localStorage['currentPath'] = btoa(JSON.stringify(pathInfo));

    // FireFox has a bug where localStorage gets erased if domain changes during workflow (e.g. OAuth sign in) in private window.
    // As a fall-back we store data to localStorage, too:
    sessionStorage.setItem('currentPath-local', btoa(JSON.stringify(pathInfo)));
  }

  getLoginPage(lang, siteVersion, siteLogo) {
    var promise = new Promise((resolve, reject) => {
      this.http.get("api/getloginpage?Lang=" + lang + "&SiteVersion=" + siteVersion + "&SiteLogo=" + siteLogo).subscribe({
        next: (data: any) => resolve(data),
        error: (err: Error) => reject(this.logger.logApiError(err, "getLoginPage"))
      });
    });
    return promise;    
  }

  setUpgradeStrings(title, description) {
    window.localStorage['upgradeStringsTitle'] = title;
    window.localStorage['upgradeStringsDescription'] = description;

    // FireFox has a bug where localStorage gets erased if domain changes during workflow (e.g. OAuth sign in) in private window.
    // As a fall-back we store data to localStorage, too:
    sessionStorage.setItem('upgradeStringsTitle-local', title);
    sessionStorage.setItem('upgradeStringsDescription-local', description);
  }

  setActionAfterOrderComplete(action) {
    window.localStorage['actionAfterOrderComplete'] = action;

    // FireFox has a bug where localStorage gets erased if domain changes during workflow (e.g. OAuth sign in) in private window.
    // As a fall-back we store data to localStorage, too:
    sessionStorage.setItem('actionAfterOrderComplete-local', action);
  }
   
  setSkuToLookAfterOrderComplete(sku) {
    window.localStorage['skuToLookAfterOrderComplete'] = sku;

    // FireFox has a bug where localStorage gets erased if domain changes during workflow (e.g. OAuth sign in) in private window.
    // As a fall-back we store data to localStorage, too:
    sessionStorage.setItem('skuToLookAfterOrderComplete-local', sku);
  }

  getSkuToLookAfterOrderComplete() {
    var sku = window.localStorage['skuToLookAfterOrderComplete'];
    if (sku === null || sku === undefined)
      sku = sessionStorage.getItem('skuToLookAfterOrderComplete-local');

    if (sku === null || sku === undefined) return null;
    return sku;
  }

  getUpgradeStrings() {
    var savedTitle = window.localStorage['upgradeStringsTitle'];
    var savedDescription = window.localStorage['upgradeStringsDescription'];
    if (savedTitle === null || savedTitle === undefined)
      savedTitle = sessionStorage.getItem('upgradeStringsTitle-local');
    if (savedDescription === null || savedDescription === undefined)
      savedDescription = sessionStorage.getItem('upgradeStringsDescription-local');

    if (savedTitle === null || savedTitle === undefined || savedDescription === null || savedDescription === undefined) return { title: null, description: null };
    return { title: savedTitle, description: savedDescription };
  }

  getActionAfterOrderComplete() {
    var action = window.localStorage['actionAfterOrderComplete'];
    if (action === null || action === undefined)
      action = sessionStorage.getItem('actionAfterOrderComplete-local');

    if (action === null || action === undefined) return null;
    return action;
  }
}

